import { reporter } from '~/hooks/useErrorReporter';
import Validation from '~/util/Validation';
import { REDIRECT_URI } from '../../constants';
import { EmailDatacenter } from '~/graphql/types';

export const getNylasDatacenter = ({
  accountId,
}: {
  accountId: string;
}): { datacenter: EmailDatacenter; clientId: string } => {
  switch (accountId) {
    case 'a---1140aaee-5b83-4149-9832-e820a49496ae':
    case 'a---53d76bbb-0703-48ff-8dbe-0d944dfec752': // Devs @ Prod
    case 'a---3e1c0288-2843-4353-a6b4-2fee76788bf2': {
      return {
        datacenter: EmailDatacenter.Eu,
        clientId: process.env.NYLAS_V3_CLIENT_ID_EU ?? 'NYLAS_V3_CLIENT_ID_EU',
      };
    }
  }

  return {
    datacenter: EmailDatacenter.Us,
    clientId: process.env.NYLAS_V3_CLIENT_ID_US ?? 'NYLAS_V3_CLIENT_ID_US',
  };
};

/**
 * Returns the link to sign in via Nylas
 * @param {string} state
 * @param {string} email
 * keywords: nylaslink
 */
const getNylasLink = ({
  state,
  email,
  accountId,
}: {
  state: string;
  accountId: string;
  email?: string;
}): string => {
  const { datacenter, clientId } = getNylasDatacenter({ accountId });

  let link = `https://api.${datacenter.toLowerCase()}.nylas.com/v3/connect/auth?client_id=${clientId}&response_type=code`;

  if (email && Validation.Email.isValid(email)) {
    link = link + `&login_hint=${email}`;
  }

  link = link + `&redirect_uri=${REDIRECT_URI}`;

  if (!Validation.String.isNonEmptyString(state)) {
    reporter.captureException(
      new Error(
        'Error while trying to build Nylas link because the state is not a string.',
      ),
    );
    return '';
  }

  if (state.length > 255) {
    reporter.captureException(
      new Error(
        `Error while trying to build Nylas link because the state: ${state} is too long. Max length is 255 characters.`,
      ),
    );
    return '';
  }

  link = link + `&state=${state}`;

  return link;
};

export default getNylasLink;
